export default __webpack_public_path__ + "static/box-mo-b09bea06937c03ba6ac69c1208fc738a.png";